import React from "react";

import { NewsletterCard, NewsletterCardProps } from "@themuse/design-system";
import { triggerSnowplowModalActionEvent } from "@themuse/snowplow-js-client";
import { newsletterSubscribeRequest, NewsletterSubmissionValues } from "utils/api";

interface NewsletterCardModuleProps {
    formRef?: (node: HTMLDivElement) => void;
    successRef?: (node: HTMLDivElement) => void;
}

const handleFormSubmit = async (formData: NewsletterSubmissionValues) => {
    const newsletterSuccess = await newsletterSubscribeRequest(formData);

    const trackingData = {
        sp_modal_type: "newsletter",
        sp_modal_error_type: null,
        sp_modal_action_type: "submit",
        sp_modal_newsletter_opt_in: null,
        sp_modal_screen_order: null,
        sp_modal_screen_name: null
    };

    if (newsletterSuccess) {
        triggerSnowplowModalActionEvent(trackingData);
    } else {
        triggerSnowplowModalActionEvent({
            ...trackingData,
            sp_modal_error_type: "Job Alerts subscription was unsuccessful."
        });
    }

    return newsletterSuccess;
};

const NewsletterCardModule = (props: NewsletterCardModuleProps) => {
    const { formRef, successRef } = props;

    const newsletterCardProps: NewsletterCardProps = {
        handleFormSubmit,
        successRef,
        formRef
    };

    return <NewsletterCard {...newsletterCardProps} />;
};

export { NewsletterCardModule };
